import { Modal } from '../modal';
import form from '../form';

export default async function startGuestSendContact(contactType, fields = {}){
  const modal = new Modal();
  modal.show(); // Content is not set so modal will be in "loading" state
  modal.setTemplate(document.getElementById('modal-template-contact').innerHTML);

  const templateData = {
    ...fields,
    contactType: {},
  };
  templateData.contactType[contactType] = true;
  modal.render(templateData);

  // This modal has submit button[data-submit] > add click handler
  const $form = modal.$content.querySelector('form');
  const $submitButton = modal.$content.querySelector('button[data-submit]');

  if($form && $submitButton){
    $submitButton.addEventListener('click', async (evt) => {
      evt.preventDefault();
      evt.stopPropagation();

      const formIsValid = form.isValid($form, true);

      if(formIsValid){

        modal.loading = true;

        const formData = form.toObject($form);

        const language = document.querySelector('html').getAttribute('lang');
        const response = await fetch(`/stage-ajax/send-guest-contact?stage-language=${language}`, {
          method: 'POST',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(formData)
        });

        const responseData = await response.json();

        if(responseData.error){
          modal.setState('error', responseData.messages || responseData.error_id);
        } else {
          modal.setState('success');
        }

        modal.loading = false;

      }

    });
  }
}
